import { render, staticRenderFns } from "./Revover.vue?vue&type=template&id=76361d4c&scoped=true&"
import script from "./Revover.vue?vue&type=script&lang=js&"
export * from "./Revover.vue?vue&type=script&lang=js&"
import style0 from "./Revover.vue?vue&type=style&index=0&id=76361d4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76361d4c",
  null
  
)

export default component.exports